var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const JSZip = require("jszip");
const FileSaver = require("file-saver");
import { zfTranslations } from "./zf_translations";
import { zfUtils } from "./zf_utils";
import { Swiper, Navigation, Pagination, A11y } from "./swiper-config";
var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["mobile"] = 375] = "mobile";
    Breakpoints[Breakpoints["tablet"] = 720] = "tablet";
    Breakpoints[Breakpoints["desktop"] = 1024] = "desktop";
    Breakpoints[Breakpoints["largeScreen"] = 1440] = "largeScreen";
})(Breakpoints || (Breakpoints = {}));
export class zfc {
    static preventDefaultEvent(e) {
        if (zfc.scrollChildSelector != null &&
            $(e.srcElement).closest(".zfch2-header2-bottom-menu-items").length) {
            var scrollTopValue = $(e.srcElement)
                .closest(zfc.scrollChildSelector)
                .scrollTop();
            var sizeOfElement = $(e.srcElement).closest(".zfch2-header2-bottom-menu-items")[0]
                .scrollHeight -
                $(e.srcElement).closest(".zfch2-header2-bottom-menu-items")[0]
                    .offsetHeight;
            if ((scrollTopValue < sizeOfElement && e.wheelDelta < 0) ||
                (scrollTopValue > 0 && e.wheelDelta > 0)) {
                return true;
            }
        }
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;
    }
    static preventDefaultForScrollKeys(e) {
        if (zfc.scrollChildSelector != null &&
            $(e.srcElement).closest(".zfch2-header2-bottom-menu-items").length) {
            var scrollTopValue = $(e.srcElement)
                .closest(zfc.scrollChildSelector)
                .scrollTop();
            var sizeOfElement = $(e.srcElement).closest(".zfch2-header2-bottom-menu-items")[0]
                .scrollHeight -
                $(e.srcElement).closest(".zfch2-header2-bottom-menu-items")[0]
                    .offsetHeight;
            if ((scrollTopValue < sizeOfElement && e.wheelDelta < 0) ||
                (scrollTopValue > 0 && e.wheelDelta > 0)) {
                return true;
            }
        }
        if (zfc.keys[e.keyCode]) {
            if (e.preventDefault)
                e.preventDefault();
            e.returnValue = false;
            return false;
        }
    }
    static disableScroll(exceptChildrenOf) {
        zfc.scrollChildSelector = exceptChildrenOf;
        if (window.addEventListener)
            window.addEventListener("DOMMouseScroll", zfc.preventDefaultEvent, false);
        window.onwheel = zfc.preventDefaultEvent;
        window.ontouchmove = zfc.preventDefaultEvent;
        document.onkeydown = zfc.preventDefaultForScrollKeys;
    }
    static enableScroll() {
        zfc.scrollChildSelector = null;
        if (window.removeEventListener)
            window.removeEventListener("DOMMouseScroll", zfc.preventDefaultEvent, false);
        window.onwheel = null;
        window.ontouchmove = null;
        document.onkeydown = null;
    }
    static getDebounceFunction(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    }
    static registerOn(target, cb, key, unattachEvent) {
        target[key] = cb;
    }
    static onMatch(qry) {
        var mql, matchQry;
        if (qry.maxWidth && qry.minWidth) {
            matchQry =
                "(min-width:" +
                    qry.minWidth +
                    "px) and (max-width:" +
                    qry.maxWidth +
                    "px)";
        }
        else if (qry.maxWidth) {
            matchQry = "(max-width: " + qry.maxWidth + "px)";
        }
        else if (qry.minWidth) {
            matchQry = "(min-width: " + qry.minWidth + "px)";
        }
        else {
            return;
        }
        if (zfc.matchQrys[matchQry]) {
            mql = zfc.matchQrys[matchQry];
        }
        else {
            mql = zfc.matchQrys[matchQry] = window.matchMedia(matchQry);
        }
        zfc.matchCheck.push(function () {
            if (mql.matches) {
                qry.callback();
            }
        });
        mql.addListener(function (e) {
            if (e.matches) {
                qry.callback();
            }
        });
    }
    static shortenText(text, limit) {
        var words = text.replace(/</gi, " <").split(" ");
        var result = "";
        var strLength = 0;
        var aInclude = false;
        var ulInclude = false;
        var ulIncludeCount = 0;
        words.forEach(function (word) {
            if (strLength >= limit && !ulInclude && !aInclude)
                return;
            else if (word.indexOf("<a") > -1) {
                result = result + " " + word;
                aInclude = true;
            }
            else if (aInclude) {
                if (word.indexOf(">") > -1) {
                    aInclude = false;
                    strLength += word.split(">")[1].length + 1;
                }
                result = result + " " + word;
            }
            else if (word.indexOf("<ul>") > -1) {
                result = result + " " + word;
                strLength += word.length + 1;
                ulInclude = true;
                ulIncludeCount++;
            }
            else if (ulInclude) {
                if (word.indexOf("</ul>") > -1) {
                    ulIncludeCount--;
                    if (ulIncludeCount == 0)
                        ulInclude = false;
                }
                result = result + " " + word;
                strLength += word.length + 1;
            }
            else if (strLength + word.length + 1 <= limit) {
                result = result + " " + word;
                strLength += word.length + 1;
            }
            else
                strLength = limit;
        });
        return result.trim();
    }
    static limitText() {
        var that = $(this);
        var maxLength = that.data("text-limit");
        var croppedText = "";
        var dots;
        var textWrapper;
        var restText;
        var moreTextBtn;
        if (that.text().trim().length <= maxLength) {
            return;
        }
        croppedText = zfc.shortenText(that.html().trim(), maxLength);
        restText = that.html().trim().replace(croppedText.replace(/ </gi, "<"), "");
        textWrapper = $('<div class="zfc-cropped-text">' + croppedText + "</div>");
        if (restText == "") {
            dots = $('<span class="zfc-cropped-text-dots" style="display: none">...</span>');
        }
        else {
            dots = $('<span class="zfc-cropped-text-dots">...</span>');
        }
        restText = $('<span class="zfc-cropped-text-rest">' + restText + "</span>");
        moreTextBtn = $('<span class="zfc-show-more-link-tag"></span>');
        moreTextBtn.append($('<button class="zfc-show-more-link-text">' +
            zfTranslations.get("read_more") +
            "</button>"));
        moreTextBtn.append($('<span class="zfc-show-more-link-icon zfcui-icon zfcui-icon-arrow-big-thin-d" role="button"></span>'));
        moreTextBtn.on("click", function (e) {
            e.preventDefault();
            var textWrapperHeight = textWrapper.height();
            if (!that.hasClass("zfc-show-more-toggled")) {
                restText.show();
                dots.hide();
                textWrapper.css({
                    height: textWrapperHeight,
                });
                textWrapper.animate({
                    height: restText.outerHeight() + textWrapperHeight,
                });
                that.addClass("zfc-show-more-toggled");
                moreTextBtn
                    .find(".zfc-show-more-link-text")
                    .text(zfTranslations.get("read_less"));
            }
            else {
                textWrapper.animate({
                    height: textWrapperHeight,
                }, function () {
                    dots.show();
                    restText.hide();
                    textWrapper.css({
                        height: "",
                    });
                });
                moreTextBtn
                    .find(".zfc-show-more-link-text")
                    .text(zfTranslations.get("read_more"));
                that.removeClass("zfc-show-more-toggled");
            }
        });
        textWrapper.append(dots);
        textWrapper.append(restText);
        that.html(textWrapper);
        that.append(moreTextBtn);
    }
    static toTopInit() {
        function createToTopElement(txtTop) {
            var button = $('<div class="zfc-to-top zfc-to-top-hidden" tabindex="0" aria-label="Back to the top" role="button"></div>')
                .append($('<span class="zfc-to-top-button zfcui-icon zfcui-icon-arrow-big-thin-u"></span>'))
                .append($('<p class="zfc-to-top-text">' +
                (txtTop != undefined ? txtTop : "Back to Top") +
                "</p>"))
                .on("click", function () {
                $("html,body").stop(true, false).animate({ scrollTop: 0 }, "slow");
                return false;
            });
            return button;
        }
        var toTopButton = createToTopElement();
        $("body").append(toTopButton);
        function slideNavUp() {
            $(".zfc-to-top")
                .removeClass("zfc-to-top-hidden")
                .addClass("zfc-to-top-visible");
            if (window.innerWidth <= 960) {
                $(".zfc-sideNav").addClass("zfc-sideNav-raised");
            }
        }
        function slideNavDown() {
            $(".zfc-to-top")
                .removeClass("zfc-to-top-visible")
                .addClass("zfc-to-top-hidden");
            if (window.innerWidth <= 960) {
                $(".zfc-sideNav").removeClass("zfc-sideNav-raised");
            }
        }
        var scrollTimeoutId = undefined;
        function hideToTopBtn() {
            slideNavDown();
            scrollTimeoutId = undefined;
        }
        function showToTopBtn() {
            slideNavUp();
            if (scrollTimeoutId != undefined)
                clearTimeout(scrollTimeoutId);
            scrollTimeoutId = setTimeout(hideToTopBtn, 3000);
        }
        function handleToTopBtnScroll() {
            if (zfUtils.scrollTop ||
                $(document.documentElement).scrollTop() ==
                    $(document).height() - document.documentElement.clientHeight)
                showToTopBtn();
            else
                hideToTopBtn();
        }
        zfUtils.onScroll({ direction: "end", callback: handleToTopBtnScroll });
        toTopButton.on("click", function () {
            $("html,body")
                .stop(true, false)
                .animate({ scrollTop: 0 }, "slow")
                .focus();
            return false;
        });
        hideToTopBtn();
    }
    static initModal() {
        if ($(".zfcui-modal").length) {
            zfc.modal = $(".zfcui-modal").eq(0);
            zfc.modalContent = zfc.modal.find(".zfcui-modal-content").eq(0);
        }
        else {
            var modal = $("<div>", { class: "zfcui-modal modal fade" });
            var modalContent = $("<div>", { class: "zfc-wrapper-content" });
            var modalContentTitle = $("<div>", { class: "row" }).append($("<button>", {
                class: "zfcui-modal-close zfcui-icon zfcui-icon-cross",
                "data-dismiss": "modal",
            }));
            var modalDialog = $('<div class="zfcui-modal-content modal-dialog"></div>');
            modal.append(modalContent);
            modalContent.append(modalContentTitle);
            modalContent.append($("<div>", { class: "row" }).append($("<div>", {
                class: "zfcui-modal-content-wrapper zfc-overlay-content-wrapper",
            })));
            modalContent.find(".zfcui-modal-content-wrapper").append(modalDialog);
            $("body").append(modal);
            zfc.modal = $(".zfcui-modal").eq(0);
            zfc.modalContent = modalDialog;
        }
        zfc.keyboardEnterToClick(zfc.modalContent.closest(".zfcui-modal").find(".zfcui-modal-close"));
        zfc.modalContent
            .closest(".zfcui-modal")
            .find(".zfcui-modal-close")
            .off("click.zfc")
            .on("click.zfc", function () {
            zfc.modalContent.closest(".zfcui-modal").hide();
            if (zfc.currentModalTarget != null) {
                if (zfc.modalContent.parent().hasClass("swiper-initialized"))
                    var swiperInstance = document.querySelector("#" + zfc.modalContent.parent().attr('id'));
                if (swiperInstance && swiperInstance.swiper) {
                    swiperInstance.swiper.destroy();
                    zfc.modalContent.parent().removeClass("swiper swiper-initialized swiper-horizontal swiper-backface-hidden");
                    zfc.modalContent.removeClass("swiper-wrapper").removeAttr("style");
                    zfc.modalContent.children().removeClass("swiper-slide");
                    zfc.modalContent.parent().find(".swiper-button-prev").remove();
                    zfc.modalContent.parent().find(".swiper-pagination").remove();
                    zfc.modalContent.parent().find(".swiper-button-next").remove();
                }
                zfc.modalTargets[zfc.currentModalTarget].placeHolder.replaceWith(zfc.modalTargets[zfc.currentModalTarget].content);
            }
            zfc.modalContent.html("");
            zfc.modal.type = null;
            zfc.currentModalTarget.indexOf("3d_model") == 0 ? $(".zfccta-button[data-modal-uuid=" + zfc.currentModalTarget + "]").focus() : null;
        });
        $("[data-modal-uuid]").each(zfc.modalize);
        $(".zfcui-modal")
            .off("click.zfc")
            .on("click.zfc", function (e) {
            if (e.target !== this)
                return;
            zfc.modalContent
                .closest(".zfcui-modal")
                .find(".zfcui-modal-close")
                .click();
        });
    }
    static prepareGenericModal(context, target) {
        var that = context;
        var targetContent = $('[data-key="' + target + '"]');
        zfc.modal.type = "generic";
        if (targetContent.length) {
            if ($(context).closest(".zfcpfst-slider-popup").length) {
                target = $(context).closest(".zfcpfst-slider-popup").attr("id");
                if (zfc.modalTargets[target]) {
                }
                else {
                    zfc.modalTargets[target] = {
                        title: "",
                        placeHolder: $("<!-- -->"),
                        content: $(context)
                            .closest(".zfcpfst-slider-popup")
                            .find(".zfcacc-accordion-content-component"),
                        callback: targetContent.data("callback"),
                    };
                }
            }
            else if ($(window).width() <= 720 &&
                $(context).closest(".row").hasClass("zfcpfst-mobile-slider-popup")) {
                target = $(context).closest(".zfcpfst-product-finder-stage").attr("id");
                if (zfc.modalTargets[target]) {
                }
                else {
                    zfc.modalTargets[target] = {
                        title: "",
                        placeHolder: $("<!-- -->"),
                        content: $(context)
                            .closest(".zfcpfst-product-finder-stage")
                            .find(".zfcacc-accordion-content-component"),
                        callback: targetContent.data("callback"),
                    };
                }
            }
            else {
                zfc.modalTargets[target] = {
                    title: targetContent.text(),
                    placeHolder: $("<!-- -->"),
                    content: targetContent
                        .closest(".zfcacc-item")
                        .find(".zfcacc-accordion-section-content"),
                    callback: targetContent.data("callback"),
                };
            }
        }
        zfc.keyboardEnterToClick(that);
        that.off("click.zfcModal").on("click.zfcModal", function (e) {
            if ($(window).width() >= 720 ||
                targetContent == undefined ||
                $(context).closest(".zfcpfst-slider-popup").length ||
                $(context).closest(".row").hasClass("zfcpfst-mobile-slider-popup") ||
                context.closest(".zfc-sideNav").length ||
                that.closest(".psv-markers").length) {
                zfc.currentModalTarget = target;
                zfc.modalTargets[target].placeHolder.insertAfter(zfc.modalTargets[target].content);
                zfc.modalContent.append(zfc.modalTargets[target].content.clone());
                if ($(context).closest(".zfcpfst-slider-popup").length ||
                    $(context).closest(".row").hasClass("zfcpfst-mobile-slider-popup")) {
                    zfc.modalContent
                        .parent()
                        .addClass("swiper")
                        .attr("id", "modal_slider");
                    zfc.modalContent.addClass("swiper-wrapper");
                    zfc.modalContent.children().addClass("swiper-slide");
                    if (zfc.modalContent.parent().find(".swiper-button-prev").length == 0) {
                        zfc.modalContent
                            .parent()
                            .prepend('<div class="swiper-button-prev"></div>');
                        zfc.modalContent
                            .parent()
                            .append('<div class="swiper-pagination"></div><div class="swiper-button-next"></div>');
                    }
                    var hasMultipleModalSlides = zfc.modalContent.children().length > 1;
                    const swiper = new Swiper("#" + zfc.modalContent.parent().attr("id"), {
                        modules: [Navigation, Pagination, A11y],
                        centeredSlides: false,
                        loop: false,
                        normalizeSlideIndex: true,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        breakpoints: {
                            720: {
                                allowTouchMove: false,
                                slidesPerView: 1,
                                navigation: {
                                    enabled: hasMultipleModalSlides,
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                },
                                pagination: {
                                    enabled: true,
                                    el: ".swiper-pagination",
                                    type: "custom",
                                    clickable: true,
                                    renderCustom: function (swiper, current, total) {
                                        var out = "";
                                        for (var i = 1; i < total + 1; i++) {
                                            if (i == current) {
                                                out =
                                                    out +
                                                        '<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex=' +
                                                        i +
                                                        ' role="button" aria-label="Go to slide ' +
                                                        i +
                                                        1 +
                                                        '"></span>';
                                            }
                                            else {
                                                out =
                                                    out +
                                                        '<span class="swiper-pagination-bullet" tabindex=' +
                                                        i +
                                                        ' role="button" aria-label="Go to slide ' +
                                                        i +
                                                        1 +
                                                        '"></span>';
                                            }
                                        }
                                        return out;
                                    },
                                },
                            },
                            0: {
                                allowTouchMove: true,
                                slidesPerView: 1,
                                spaceBetween: 0,
                                navigation: {
                                    enabled: false,
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                },
                                pagination: {
                                    enabled: true,
                                    el: ".swiper-pagination",
                                    type: "custom",
                                    clickable: true,
                                    renderCustom: function (swiper, current, total) {
                                        var out = "";
                                        for (var i = 1; i < total + 1; i++) {
                                            if (i == current) {
                                                out =
                                                    out +
                                                        '<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex=' +
                                                        i +
                                                        ' role="button" aria-label="Go to slide ' +
                                                        i +
                                                        1 +
                                                        '"></span>';
                                            }
                                            else {
                                                out =
                                                    out +
                                                        '<span class="swiper-pagination-bullet" tabindex=' +
                                                        i +
                                                        ' role="button" aria-label="Go to slide ' +
                                                        i +
                                                        1 +
                                                        '"></span>';
                                            }
                                        }
                                        return out;
                                    },
                                },
                            },
                        },
                        a11y: {
                            enabled: true,
                            containerMessage: "Modal Popup slider",
                            containerRoleDescriptionMessage: "Modal Popup slider container",
                            nextSlideMessage: "Next slide",
                            prevSlideMessage: "Previous slide",
                            paginationBulletMessage: "Jump to slide {{index}}",
                            slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                            slideRole: "group",
                            itemRoleDescriptionMessage: "slide",
                        },
                    });
                    swiper.init();
                    swiper.slideTo(that.data("index"));
                }
                else {
                    if (zfc.modalContent.find(".zfcgac-gallery-alternative-component").length >= 1 &&
                        zfc.modalContent.find(".zfcgac-gallery-alternative-component .swiper-wrapper").children().length == 1) {
                        zfc.modalContent
                            .parent()
                            .removeClass("swiper swiper-initialized swiper-horizontal swiper-backface-hidden");
                        zfc.modalContent.removeClass("swiper-wrapper").removeAttr("style");
                        zfc.modalContent.children().removeClass("swiper-slide");
                        zfc.modalContent.parent().find(".swiper-button-prev").remove();
                        zfc.modalContent.parent().find(".swiper-pagination").remove();
                        zfc.modalContent.parent().find(".swiper-button-next").remove();
                    }
                    zfc.modalContent.find(".swiper-notification").remove();
                }
                zfc.modalContent.closest(".zfcui-modal").css("display", "flex");
                Object.keys(zfc.modalCallbacks).forEach(function (key) {
                    if (zfc.modalContent.find(key).length)
                        zfc.modalCallbacks[key](zfc.modalContent.find(key));
                });
                zfc.modalContent.closest(".zfcui-modal").find(".zfcui-modal-close").focus();
            }
            else {
                targetContent.closest(".zfcacc-item")[0].slideOpen(function () {
                    $("html, body").animate({
                        scrollTop: targetContent.offset().top - 72,
                    });
                });
            }
            $(".zfcui-modal")
                .find('a[href*="#"]')
                .each(function () {
                $(this).attr("href", $(this).attr("href").replace("#", "?pageLink="));
            });
            e.preventDefault();
        });
    }
    static mqMinWidth960() {
        return window.matchMedia("(min-width: 960px)");
    }
    static handleModalBackdrop() {
        if (zfc.modalBackdropListenerBound)
            return;
        zfc.modalBackdropListenerBound = true;
        zfc.mqMinWidth960().addListener(function () {
            if ($(".side-nav-share.show").length) {
                if (zfc.mqMinWidth960().matches) {
                    $(".modal-backdrop").css("bottom", "0px");
                }
                else {
                    $(".modal-backdrop").css("bottom", "70px");
                }
            }
        });
    }
    static modalize() {
        var that = $(this);
        var target = that.data("modal-uuid");
        zfc.handleModalBackdrop();
        if (!target) {
            return;
        }
        zfc.prepareGenericModal(that, target);
    }
    static elementInViewport(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;
        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }
        return (top >= window.pageYOffset &&
            left >= window.pageXOffset &&
            top + height <= window.pageYOffset + window.innerHeight &&
            left + width <= window.pageXOffset + window.innerWidth);
    }
    static elementPartlyInViewport(elem) {
        if (typeof elem == "undefined")
            return false;
        var x = elem.getBoundingClientRect().left;
        var y = elem.getBoundingClientRect().top;
        var ww = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        var hw = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        var w = elem.clientWidth;
        var h = elem.clientHeight;
        return y < hw && y + h > 0 && x < ww && x + w > 0;
    }
    static keyboardEnterToClick(elem) {
        elem
            .off("keypress.zfcEnter")
            .on("keypress.zfcEnter", function (e) {
            if (e.which == 13) {
                e.preventDefault();
                elem.click();
            }
        });
    }
    static keyboardEscToClose() {
        if (zfc.escListenerBound)
            return;
        zfc.escListenerBound = true;
        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
                event.preventDefault();
                if ($(".zfc-lightbox-overlay-close").is(":visible")) {
                    $(".zfc-lightbox-overlay-close").click();
                }
                if ($(".zfcui-modal-close").is(":visible")) {
                    $(".zfcui-modal-close").click();
                }
                if ($(".zfctl-item-video-close").is(":visible")) {
                    $(".zfctl-item-video-close").click();
                }
                if ($(".zfch2-header2-burger-menu[aria-expanded='true']").is(":visible")) {
                    $(".zfch2-header2-burger-menu").click();
                }
            }
        });
    }
    static webEditFunctions() {
        $(".zfcui-preview-url > a").off("click.zfcWebEdit");
        $(".zfcui-preview-url").off("click.zfcWebEdit");
        $(".zfcui-preview-url").on("click.zfcWebEdit", function (e) {
            var copiedUrl = $(this).find("a").attr("href");
            if (navigator.clipboard) {
                $(".zfcui-preview-url").find("a").focus();
                setTimeout(() => __awaiter(this, void 0, void 0, function* () { return console.log(yield navigator.clipboard.writeText(copiedUrl)); }), 1000);
                $(".zfcui-preview-url")
                    .find(".zfcui-preview-url-copy-confirmation > .zfcui-preview-url-popup")
                    .text("Copy Success");
                $(".zfcui-preview-url")
                    .find(".zfcui-preview-url-copy-confirmation")
                    .fadeIn("fast");
                setTimeout(function () {
                    $(".zfcui-preview-url")
                        .find(".zfcui-preview-url-copy-confirmation")
                        .fadeOut("slow");
                }, 3000);
            }
            else {
                $(".zfcui-preview-url")
                    .find(".zfcui-preview-url-copy-confirmation > .zfcui-preview-url-popup")
                    .text("Copy Failed");
                $(".zfcui-preview-url")
                    .find(".zfcui-preview-url-copy-confirmation")
                    .fadeIn("fast");
                setTimeout(function () {
                    $(".zfcui-preview-url")
                        .find(".zfcui-preview-url-copy-confirmation")
                        .fadeOut("slow");
                }, 3000);
            }
        });
    }
    static createZip(name, contents, textPrefix) {
        return __awaiter(this, void 0, void 0, function* () {
            zfUtils.displaySpinner();
            try {
                var zip = new JSZip();
                var count = 0;
                for (var index = 0; index < contents.length; index++) {
                    if (contents[index].indexOf("http") != -1 &&
                        contents[index].indexOf("zf.com/kaltura/") == -1) {
                        var response = yield fetch(contents[index]);
                        if (response.status == 200) {
                            var nameParts = contents[index].split("/");
                            var contentName = nameParts[nameParts.length - 1];
                            var contentBlob = yield response.blob();
                            zip.file(contentName, contentBlob);
                        }
                    }
                    else {
                        count++;
                        zip.file(textPrefix + "_" + count + ".txt", contents[index]);
                    }
                }
                var content = yield zip.generateAsync({ type: "blob" });
                FileSaver.saveAs(content, name);
            }
            finally {
                zfUtils.hideSpinner();
            }
        });
    }
    static clickElement(selector) {
        $("." + selector).click();
    }
}
zfc.document = $(document);
zfc.window = $(window);
zfc.body = $("body");
zfc.keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
zfc.matchQrys = {};
zfc.matchCheck = [];
zfc.modalTargets = {};
zfc.modalCallbacks = {};
zfc.currentModalTarget = null;
zfc.modalBackdropListenerBound = false;
zfc.escListenerBound = false;
zfc.scrollChildSelector = null;
zfUtils.onReady(function () {
    zfc.dividerHtml = zfUtils.fsData.dividerHtml;
    zfc.btnPartHtml = zfUtils.fsData.btnPartHtml;
    zfc.initModal();
    zfc.toTopInit();
    $("[data-text-limit]").each(zfc.limitText);
    zfc.matchCheck.forEach(function (cb) {
        cb();
    });
    if ($(".zf-webedit").length > 0) {
        zfc.webEditFunctions();
    }
    zfc.keyboardEscToClose();
    $(".zfc-show-more-link-tag")
        .off("click.zfcShowMore")
        .on("click.zfcShowMore", function () {
        var that = $(this);
        if (that.parent().hasClass("zfcpfst-copy") == false) {
            that.parent().toggleClass("zfc-show-more-toggled");
        }
        if (that.parent().hasClass("zfc-show-more-toggled")) {
            that
                .find(".zfc-show-more-link-text")
                .text(zfTranslations.get("show_less"));
        }
        else {
            that
                .find(".zfc-show-more-link-text")
                .text(zfTranslations.get("show_more"));
        }
        that.parent().parent().find(".zfc-show-more-copy-text").slideToggle();
    });
    globalThis.zfc = zfc;
});
